interface HighlightProps {
  text: string;
  keyword: string;
}

export default function Highlight({ text, keyword }: HighlightProps) {
  const key = keyword.trim();
  if (!key) return <>{text}</>;

  const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escaped})`, "gi"));

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === key.toLowerCase() ? (
          <mark key={index} className="bg-accent-200 text-accent-950 rounded px-0.5">
            {part}
          </mark>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </>
  );
}